import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EN_TRANSLATE } from '../mocks/en.mock';
import { HE_TRANSLATE } from '../mocks/he.mock';
import { ES_TRANSLATE } from '../mocks/es.mock';
import { RU_TRANSLATE } from '../mocks/ru.mock';
import { FR_TRANSLATE } from '../mocks/fr.mock';
import { DE_TRANSLATE } from '../mocks/de.mock';
import { PO_TRANSLATE } from '../mocks/po.mock';

@Injectable({
  providedIn: 'root'
})
export class LangService {

  private translations: { [key: string]: any } = {
    'en': EN_TRANSLATE,
    'he': HE_TRANSLATE,
    'sp': ES_TRANSLATE,
    'ru': RU_TRANSLATE,
    'fr': FR_TRANSLATE,
    'de': DE_TRANSLATE,
    'ge': DE_TRANSLATE,
    'po': PO_TRANSLATE,
  };

  constructor(
    private translate: TranslateService
  ) { }

  setLangTranslation(langName: string) {
    console.log(langName);

    const translation = this.translations[langName];
    
    if (translation) {
      this.translate.setTranslation(langName, translation);
    } else {
      console.error(`Translation for language '${langName}' not found.`);
    }
  }
}
